export const PROVINCIAL_CODE = 'PRISO';
export const UTILISATION_OTHER_CODE = '00099';
export const FEDERAL_ONLY: string[] = ['LRSP', 'RLSP', 'RLIF', 'FLIF'];
export const PROVINCIAL_ONLY: string[] = ['LIRA', 'LRIF', 'PRIF', 'LIF'];
export const INVESTCUBE = 'N';
